import { useMemo } from 'react'
import { roundDecimals } from 'tennders-stracture/libs/utils'

const useMultipleSalesInvoiceCalculateAmounts = ({
  form,
  lines,
  discountLines,
  extraCostsLines
}) => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const totalAmountOnInvoice = useMemo<number>(() => lines.reduce<number>((prev: number, next: {amount ?: number|string}) => {
    const currentValue = next?.amount ? roundDecimals(parseFloat(next.amount as string)) : 0
    return prev + currentValue
  }, 0), [lines])

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const totalAmountOnInvoiceIncVat = useMemo<number>(() => lines.reduce<number>((prev: number, next: {totalAmount ?: number|string}) => {
    const currentValue = next?.totalAmount ? roundDecimals(parseFloat(next.totalAmount as string)) : 0
    return prev + currentValue
  }, 0), [lines])

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const totalExtraCosts = useMemo<number>(() => extraCostsLines.reduce<number>((prev: number, next: {amount ?: number|string}) => {
    const currentValue = next?.amount ? roundDecimals(parseFloat(next.amount as string)) : 0
    return prev + currentValue
  }, 0), [extraCostsLines])

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const totalExtraCostsVat = useMemo<number>(() => extraCostsLines.reduce<number>((prev: number, next: {vatAmount ?: number|string}) => {
    const currentValue = next?.vatAmount ? roundDecimals(parseFloat(next.vatAmount as string)) : 0
    return prev + currentValue
  }, 0), [extraCostsLines])

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const totalLineVat = useMemo<number>(() => lines.reduce<number>((prev: number, next: {vatAmount ?: number|string}) => {
    const currentValue = next?.vatAmount ? roundDecimals(parseFloat(next.vatAmount as string)) : 0

    return prev + currentValue
  }, 0), [lines])

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const totalDiscount = useMemo<number>(() => discountLines.reduce<number>((prev: number, next: {amount ?: number|string}) => {
    const currentValue = next?.amount ? roundDecimals(parseFloat(next.amount as string)) : 0
    return prev + currentValue
  }, 0), [discountLines])

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const totalExtraCostsIncVat = useMemo<number>(() => extraCostsLines.reduce<number>((prev: number, next: {totalAmount ?: number|string}) => {
    const currentValue = next?.totalAmount ? roundDecimals(parseFloat(next.totalAmount as string)) : 0
    return prev + currentValue
  }, 0), [extraCostsLines])

  const calculateTotalDiscount = useMemo(() => {
    let totalDiscountAmount = 0

    discountLines.forEach((line) => {
      totalDiscountAmount += line.totalAmount
    })

    return totalDiscountAmount
  }, [lines, totalExtraCosts, discountLines, totalAmountOnInvoice, totalExtraCosts])

  const totalDiscountVat = calculateTotalDiscount - totalDiscount
  const totalVatAmount = totalLineVat - totalDiscountVat + totalExtraCostsVat
  const totalEndAmountToPay = (totalAmountOnInvoice + totalExtraCosts) + totalVatAmount - totalDiscount
  return {
    totalAmountOnInvoice,
    totalExtraCosts,
    calculateTotalDiscount,
    totalAmountOnInvoiceIncVat,
    totalExtraCostsIncVat,
    totalEndAmountToPay,
    totalDiscount,
    totalVatAmount
  }
}

export default useMultipleSalesInvoiceCalculateAmounts
